import { defineComponent, openBlock, createElementBlock, withModifiers, createElementVNode, renderSlot, normalizeClass } from 'vue';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "button",
  props: {
    disabled: { type: Boolean, default: false },
    iconClass: { default: "" }
  },
  emits: ["click"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    function buttonClickHandler() {
      emit("click");
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("button", {
        type: "button",
        disabled: __props.disabled,
        class: "se-button",
        onClick: buttonClickHandler,
        onMousedown: withModifiers(() => {
        }, ["prevent"])
      }, [
        createElementVNode("div", { class: "se-button-icon" }, [
          renderSlot(_ctx.$slots, "icon", {}, () => [
            createElementVNode("span", {
              class: normalizeClass(__props.iconClass)
            }, null, 2)
          ], true)
        ]),
        createElementVNode("div", { class: "se-button-text" }, [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ])
      ], 40, ["disabled", "onMousedown"]);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=button.vue.js.map
